import { createFilterOptions } from '@mui/material/Autocomplete';
import Teacher from '../model/Teacher';

/** Usuwa duplikaty po id (np. gdy API lub Autocomplete łączy listy). */
export function dedupeTeachersById(teachers: Teacher[]): Teacher[] {
	const seen = new Set<number>();
	const result: Teacher[] = [];
	for (const t of teachers) {
		if (!t.id || seen.has(t.id)) {
			continue;
		}
		seen.add(t.id);
		result.push(t);
	}
	return result;
}

/** Etykieta na liście — przy tym samym imieniu i nazwisku dopisz e-mail. */
export function teacherOptionLabel(teacher: Teacher, allTeachers: Teacher[]): string {
	const base = `${teacher.firstName} ${teacher.lastName}`.trim();
	const sameNameCount = allTeachers.filter(
		(t) => `${t.firstName} ${t.lastName}`.trim().toLocaleLowerCase('pl') === base.toLocaleLowerCase('pl'),
	).length;
	if (sameNameCount > 1 && teacher.email) {
		return `${base} (${teacher.email})`;
	}
	return base;
}

export const filterTeacherOptions = createFilterOptions<Teacher>({
	ignoreCase: true,
	stringify: (t) => `${t.firstName} ${t.lastName} ${t.email} ${t.affiliation}`.trim(),
});
